/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$r as $r,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
} from "../../runtime/index.jsx";
export function Componente_HS_72_83(e) {
  return (
    <li
      key={e.id}
      className={`flex items-center gap-2`}
      children={[
        (0, JSXRuntime.jsx)($r, {
          className: `h-3.5 w-3.5 shrink-0 text-(--text)`,
        }),
        <a
          href={e.url}
          target={`_blank`}
          rel={`noreferrer`}
          className={`min-w-0 truncate text-(--accent) hover:underline`}
          children={e.descripcion || e.url}
        />,
      ]}
    />
  );
}
